export default function AnimatedText({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <span className="inline-block pr-[2px] bg-gradient-to-r from-[#7253F5] via-[#C466FF] to-[#7253F5] bg-[length:400%_100%] bg-clip-text text-transparent animate-textSmooth">
      {children}
    </span>
  )
}
